import { Stack, Typography } from "@mui/material";
import { useState } from "react";
import BadgeDetached from "@entrilia/shared/components/BadgeDetached";
import ItemsListPopover from "@entrilia/shared/components/ItemsListPopover";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import { defined } from "@entrilia/shared/utilities/typeHelper";

interface Props {
  items: string[];
  subItem?: string;
  fontWeight: "normal" | "bold";
}

const InlineItemsWithBadge = ({ items, subItem, fontWeight }: Props) => {
  const [popUpAnchorEl, setPopUpAnchorEl] = useState<HTMLElement>();

  if (items.length === 0) {
    return null;
  }

  const firstItem = defined(items[0]);
  const remainingItems = items.slice(1);

  const handleBadgeClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    e.preventDefault();

    setPopUpAnchorEl((prev) => (prev ? undefined : e.currentTarget));
  };

  return (
    <Stack direction="row" spacing={0.5} sx={{ alignItems: "center", maxWidth: "100%" }}>
      <Stack sx={{ pr: 1, py: 1, maxWidth: "100%" }}>
        <TypographyTooltipEllipsis text={firstItem} typographyProps={{ sx: { fontWeight } }} />
        {subItem && (
          <TypographyTooltipEllipsis
            text={subItem}
            typographyProps={{ variant: "caption", sx: { color: "text.secondary", fontWeight } }}
          />
        )}
      </Stack>
      {remainingItems.length > 0 && (
        <BadgeDetached
          color="secondary"
          badgeContent={"+" + remainingItems.length}
          onClick={handleBadgeClick}
          sx={{ cursor: "pointer" }}
        />
      )}
      <ItemsListPopover anchorEl={popUpAnchorEl} onClose={() => setPopUpAnchorEl(undefined)}>
        <Stack spacing={1} sx={{ maxWidth: "25rem", p: 1 }}>
          {remainingItems.map((item, index) => (
            // eslint-disable-next-line @eslint-react/no-array-index-key
            <Typography noWrap key={index}>
              {item}
            </Typography>
          ))}
        </Stack>
      </ItemsListPopover>
    </Stack>
  );
};

export default InlineItemsWithBadge;
